import { render, staticRenderFns } from "./ProjectTaskEditFrProject.vue?vue&type=template&id=0d307fca"
import script from "./ProjectTaskEditFrProject.vue?vue&type=script&lang=js"
export * from "./ProjectTaskEditFrProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports